import type { FC, SVGProps } from 'react'

export const FileArrowUp: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="33"
    height="33"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M25.9224 28.4028H7.92236C7.65715 28.4028 7.40279 28.2975 7.21526 28.1099C7.02772 27.9224 6.92236 27.668 6.92236 27.4028V5.40283C6.92236 5.13762 7.02772 4.88326 7.21526 4.69573C7.40279 4.50819 7.65715 4.40283 7.92236 4.40283H19.9224L26.9224 11.4028V27.4028C26.9224 27.668 26.817 27.9224 26.6295 28.1099C26.4419 28.2975 26.1876 28.4028 25.9224 28.4028Z"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9224 4.40283V11.4028H26.9224"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4224 18.9028L16.9224 15.4028L20.4224 18.9028"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.9224 23.4028V15.4028"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
